"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TravelerSelectionContent: ()=>TravelerSelectionContent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../Button/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Disclaimer_index_cjs_namespaceObject = require("../../Disclaimer/index.cjs");
const external_Divider_index_cjs_namespaceObject = require("../../Divider/index.cjs");
const external_StatusBanner_index_cjs_namespaceObject = require("../../StatusBanner/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_constants_cjs_namespaceObject = require("../constants.cjs");
const ChildrenLineItem_cjs_namespaceObject = require("../TravelerLineItems/ChildrenLineItem.cjs");
var ChildrenLineItem_cjs_default = /*#__PURE__*/ __webpack_require__.n(ChildrenLineItem_cjs_namespaceObject);
const MaxRoomsBannerMessage_cjs_namespaceObject = require("../TravelerLineItems/MaxRoomsBannerMessage.cjs");
const TravelerLineItem_cjs_namespaceObject = require("../TravelerLineItems/TravelerLineItem.cjs");
var TravelerLineItem_cjs_default = /*#__PURE__*/ __webpack_require__.n(TravelerLineItem_cjs_namespaceObject);
function TravelerSelectionContent({ ageSelectEnabled, disclaimer, isHotel, isPopover, maxAdults, maxChildren, fireMaxRoomsOnClick, maxRooms: defaultMaxRooms = external_constants_cjs_namespaceObject.DEFAULT_MAX_ROOMS, maxRoomsMessage, maxRoomsUrl, roomsEnabled, state = {}, handleClose, subLabelMap, lapInfantLabel, shouldCountLapInfant }) {
    const { rooms = 1, adults = 1, children = 0, childrenAges = {}, lapInfants = 0, remainingTravelerCount = 0, setRooms = external_utils_index_cjs_namespaceObject.noop, setAdults = external_utils_index_cjs_namespaceObject.noop, setChildren = external_utils_index_cjs_namespaceObject.noop, setChildrenAges = external_utils_index_cjs_namespaceObject.noop, setLapInfants = external_utils_index_cjs_namespaceObject.noop, triggerValidation = external_utils_index_cjs_namespaceObject.noop } = state;
    const maxRooms = ageSelectEnabled && roomsEnabled && maxAdults && maxChildren ? Math.ceil((maxAdults + maxChildren) / external_constants_cjs_namespaceObject.ROOM_SIZE) : defaultMaxRooms;
    const finalMaxLapInfant = shouldCountLapInfant ? Math.min(adults, lapInfants + remainingTravelerCount) : adults;
    const finalMaxChildren = maxChildren ? Math.min(maxChildren, children + remainingTravelerCount) : children + remainingTravelerCount;
    const BannerMessage = (0, external_react_namespaceObject.useMemo)(()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MaxRoomsBannerMessage_cjs_namespaceObject.MaxRoomsBannerMessage, {
            maxRoomsMessage: maxRoomsMessage,
            maxRoomsUrl: maxRoomsUrl,
            fireMaxRoomsOnClick: fireMaxRoomsOnClick,
            maxRooms: maxRooms
        }), [
        maxRoomsMessage,
        maxRoomsUrl,
        fireMaxRoomsOnClick,
        maxRooms
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: 'flex h-full w-full cursor-pointer flex-col overflow-x-hidden overflow-y-scroll',
        children: [
            roomsEnabled ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TravelerLineItem_cjs_default(), {
                        label: "Rooms",
                        min: 1,
                        max: maxRooms,
                        count: rooms,
                        onChange: setRooms
                    }),
                    rooms === maxRooms ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_StatusBanner_index_cjs_namespaceObject.StatusBanner, {
                        palette: "caution",
                        emphasis: "bold",
                        captionNode: BannerMessage,
                        iconNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                            iconName: "bed"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Divider_index_cjs_namespaceObject.Divider, {})
                ]
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TravelerLineItem_cjs_default(), {
                label: "Adults",
                subLabel: subLabelMap?.adults ?? '',
                min: 1,
                max: maxAdults || adults + remainingTravelerCount,
                count: adults,
                onChange: setAdults
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Divider_index_cjs_namespaceObject.Divider, {}),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChildrenLineItem_cjs_default(), {
                ageSelectEnabled: ageSelectEnabled,
                max: finalMaxChildren,
                count: children,
                ages: childrenAges,
                isHotel: isHotel,
                onChange: setChildren,
                subLabel: subLabelMap?.children ?? 'Ages 2 to 11',
                onAgeChange: setChildrenAges
            }),
            ageSelectEnabled ? null : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Divider_index_cjs_namespaceObject.Divider, {}),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TravelerLineItem_cjs_default(), {
                        label: lapInfantLabel ?? 'Infants on Lap',
                        subLabel: subLabelMap?.lapInfants ?? 'Under 2',
                        min: 0,
                        max: finalMaxLapInfant,
                        count: lapInfants,
                        onChange: setLapInfants
                    })
                ]
            }),
            disclaimer ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Disclaimer_index_cjs_namespaceObject.Disclaimer, {
                className: "text-body3 pt-2",
                children: disclaimer
            }) : null,
            !disclaimer && roomsEnabled && ageSelectEnabled ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Disclaimer_index_cjs_namespaceObject.Disclaimer, {
                className: "text-body3 pt-2",
                children: "Add your child's age at check-in for the best deals and assistance. Each hotel has unique policies."
            }) : null,
            isPopover ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "mt-3 flex justify-end",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
                    size: "sm",
                    type: "primary",
                    onClick: (e)=>{
                        triggerValidation();
                        handleClose?.(e);
                    },
                    className: "px-4 py-2",
                    children: "Done"
                })
            }) : null
        ]
    });
}
exports.TravelerSelectionContent = __webpack_exports__.TravelerSelectionContent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TravelerSelectionContent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
